// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusBottomrightOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusBottomrightOutlined";
import AntdIcon from '../components/AntdIcon';

var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomrightOutlinedSvg
  }));
};

RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
export default /*#__PURE__*/React.forwardRef(RadiusBottomrightOutlined);